import cn from 'classnames';
import { FC, ReactNode } from 'react';
import s from './tabs-stepper.module.css';

interface Props {
  titles: ReactNode[];
  active: number;
}

export const TabsStepper: FC<Props> = (props) => {
  const { titles, active } = props;

  return (
    <ul className={s.component}>
      {titles.map((title, index) => {
        const isActive = index === active;

        return (
          <li key={index} className={cn(s.title, isActive && s.active)}>
            {title}
          </li>
        );
      })}
    </ul>
  );
};
